export const TRANSACTIONS_LOADING = "TRANSACTIONS_LOADING";
export const TRANSACTIONS_ERROR = "TRANSACTIONS_ERROR";
export const TRANSACTIONS_GET_CURRENCIES = "TRANSACTIONS_GET_CURRENCIES";
export const TRANSACTIONS_GET_STATUSES = "TRANSACTIONS_GET_STATUSES";
export const TRANSACTIONS_GET_TYPES = "TRANSACTIONS_GET_TYPES";

export const TRANSACTIONS_GET_LIST = "TRANSACTIONS_GET_LIST";
export const TRANSACTIONS_GET_FILTERS = "TRANSACTIONS_GET_FILTERS";



// WEBPACK FOOTER //
// ./src/actions/transaction/constants.js